import { iApiConfig, tAddress, tAvailableFTokens, tAvailableUTokens, tDiscountPercent, tStrategy } from "../../interfaces/interfaces";
import { tDispatch } from "../store";
import { eAppActionTypes } from "./appTypes";

export const clearAppState = () => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.CLEAR_STATE
		})
	}
}

export const setDiscountPercent = (percent: tDiscountPercent) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_DISCOUNT_PERCENT,
			payload: percent
		})
	}
}

export const setCurrentFToken = (token: tAvailableFTokens) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_CURRENT_F_TOKEN,
			payload: token
		})
	}
}

export const setCurrentUToken = (token: tAvailableUTokens) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_CURRENT_U_TOKEN,
			payload: token
		})
	}
}

export const setStrategy = (strategy: tStrategy) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_STRATEGY,
			payload: strategy
		})
	}
}

export const setUserAddress = (address: tAddress) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_USER_ADDRESS,
			payload: address
		})
	}
}

export const setApiData = (percent: tDiscountPercent, api: string, config: iApiConfig) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_API_DATA,
			payload: {
				percent,
				api,
				config
			}
		})
	}
}

export const setIsInited = () => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_IS_INITED,
			payload: true
		})
	}
}

/* export const setMinDeposit = (percent: tDiscountPercent, ftAmount: cBigNumber, utAmount: cBigNumber) => {
	return (dispatch: tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_MIN_DEPOSIT,
			payload: {
				percent,
				amounts: {
					ft: ftAmount,
					ut: utAmount
				}
			}
		})
	}
} */

export const setKasAccessToken = (token: string) => {
	return (dispatch : tDispatch) => {
		dispatch({
			type: eAppActionTypes.SET_KAS_ACCESS_TOKEN,
			payload: token
		})
	}
}